import { EntityApiService } from '@dofleini/security';

import { authentication } from '@/settings';

class TechParkApiService extends EntityApiService {

}

export default new TechParkApiService(`${authentication.path}/api/tech-parks`);
